/* Delegation also supports sections replaced by the Shopify theme editor. */
(() => {
  if (window.vnFooterNavigationReady) return;
  window.vnFooterNavigationReady = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-vn-footer-top]');
    if (!button) return;
    window.scrollTo({
      top: 0,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
    });
  });
})();
